import { P1IntegrationCertificatesSetCommandResult } from '@dreryk/egabinet-p1-frontend-api';

import { dispatchSnackbarWarningEvent } from '@dreryk/react-components';

import { certificatesFormTranslationKeys } from '../../../translations';

export const resolveCertificatesValidationWarnings = (
   validationWarnings: P1IntegrationCertificatesSetCommandResult['validationWarnings']
): void => {
   if (validationWarnings.length) {
      dispatchSnackbarWarningEvent(
         certificatesFormTranslationKeys.certificateEnteredHasDifferentDataFromThatStoredOnMyPracticeView,
         {
            autoHideDelayInMs: false,
         }
      );
   }
};
